<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="acessoConfigModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="id">
                    <div class="modal-header">
                        <h5 class="modal-title">Acesso (#{{ id }}) 
                            <span v-if="titulo">
                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                {{ titulo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados || !lista.length" 
                            icon="fas fa-user-lock"
                            :msg="dados ? 'Nenhuma regra de acesso definida.' : 'Regras de acesso definidas pelo administrador.'" 
                            :method="dados ? incluir : null" 
                            :action="dados ? 'Incluir Regra' : ''" />

                        <template v-else>

                            <div class="form-row" v-for="(item, idx) in lista" :key="idx">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="button-group"
                                        :optionsList="[{id:1,search:'Apenas'}, {id:0,search:'Exceto'}]"
                                        :validate="validate"
                                        v-model="item.fl_regra" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="[
                                            {id: 'U', search: 'Usuário'},
                                            {id: 'C', search: 'Classificação'},
                                        ]"
                                        optionsData="id"
                                        :validate="validate"
                                        required
                                        v-model="item.filtro">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" @click="item.excluido = true">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>                                
                                </div>
                                <div class="col col-12 col-md-6">
                                    <input type="text" placeholder="..." class="form form-control" disabled v-if="!item.filtro">
                                    <az-input
                                        v-else-if="item.filtro == 'C'"
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="lista_tags"
                                        optionsData="search"
                                        required 
                                        v-model="item.st_hashtag" />
                                    <az-input
                                        v-show="item.filtro == 'U'"
                                        placeholder
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="usuarios.index" 
                                        optionsName="filtro-usuarios"
                                        :optionsParm="{ where: { fl_ativo: true } }"
                                        :optionsSync="false"
                                        required 
                                        v-model="item.usuario" />
                                </div>
                            </div>

                            <br><br><br><br><br><br><br><br><br><br><br><br>

                        </template>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <button type="button" class="btn btn-primary float-left" @click="incluir()" v-if="dados">
                                <i class="fas fa-plus"></i>
                            </button>
                        </div>

                        <div>
                            <az-audit-log-button :model="this.type" :id="this.id" />
                            <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                            <az-submit @click="salvar()" v-if="dados">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            dados: null, 
            type: null, 
            id: null, 
            validate: false,
            options_classes: null, 
            titulo: null, 
            tipo: null, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState, 
        AzSubmit, 
        AzAuditLogButton, 
    },

    props: ['baselog'], 

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            return this.dados.filter(item => !item.excluido);
        },

        lista_tags: function () { 
            if ( !this.options_classes )
                return [];

            return this.options_classes.map(item => { 
                return { search: item };
            });
        },
    },

    methods: { 
        salvar() { 
            this.$util.atualizar(this, { 
                service: 'acessos',
                func: 'stores',
                dados: { 
                    items: this.dados,
                    baselog: this.baselog, 
                }, 
                modal: 'acessoConfigModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        incluir() { 
            this.dados.push({
                id_acesso: null, 
                model_type: this.type,
                model_id: this.id,
                id_usuario: null, 
                usuario: "", 
                st_hashtag: "", 
                fl_regra: true, 
                filtro: 'U',
                excluido: false, 
                st_tipo: this.tipo, 
            }); 
        },

        abrir(type, id, titulo = null, tipo = null) { 
            this.type = type;
            this.id = id;
            this.dados = null;
            this.titulo = titulo;
            this.validate = false;
            this.tipo = tipo ? tipo : null, 

            $('#acessoConfigModal').modal('show');

            if ( !this.options_classes ) { 

                this.$util.loadItem(this, { 
                    service: 'usuarios',
                    func: 'tags',
                })
                .then(res => { 
                    this.options_classes = res;
                });

            }

            this.$util.load(this, { 
                service: 'acessos',
                parms: { 
                    type: this.type,
                    id: this.id, 
                    tipo: this.tipo, 
                },
                loadTo: res => { 
                    this.dados = res;
                }
            });
        }
    },

}
</script>